var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
//widgets
import Tile from '@/widgets/Tile';
import AsyncButton from '@/widgets/AsyncButton/AsyncButton';
//filters
import Filters from './widgets/Filters';
//dls
import { Svg20 as ArrowRight } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronRight';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
//stores
import useAccountStore from '@/stores/account';
import useSearchCampaignStore from '@/stores/SearchCampaign';
//includes
import { listCampaignApi } from '@/includes/api/campaign/list';
// styles
import styles from './index.module.scss';
// componenets
import { CampaignList } from '@/components/CampaignList';
// defs
import { CampaignSearchStatus } from '@/defs/CampaignSearch';
import { CampaignStatus, CampaignStatusUpdateReason, } from '@local/typedefs/dist/protos/campaign/Campaign';
// constants
import { DlsColorTokens } from '@/constants/DLSTokens';
const IndexPage = () => {
    const { getCurrentAccountId } = useAccountStore();
    const [campaigns, setCampaigns] = useState([]);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
    const [campaignResults, setCampaignResults] = useState(() => campaigns);
    const { startDateFrom, startDateTo, endDateFrom, endDateTo, cityIds, status, pacingEnabled, selectedCampaigns, selectedAdGroupCandidates, createdBy, } = useSearchCampaignStore((state) => ({
        selectedCampaigns: state.campaignFilter.selectedCampaigns,
        selectedAdGroupCandidates: state.candidateFilter.selectedAdGroupCandidates,
        startDateFrom: state.dateFilters.startDateFrom,
        startDateTo: state.dateFilters.startDateTo,
        endDateFrom: state.dateFilters.endDateFrom,
        endDateTo: state.dateFilters.endDateTo,
        cityIds: state.cityFilter.cityIds,
        status: state.statusFilter.status,
        pacingEnabled: state.pacingFilter.pacingEnabled,
        createdBy: state.createdByFilter.createdBy,
    }));
    useEffect(() => {
        fetchCampaigns();
    }, []);
    useEffect(() => {
        applyFilters();
    }, [campaigns]);
    const fetchCampaigns = () => __awaiter(void 0, void 0, void 0, function* () {
        const accountId = yield getCurrentAccountId();
        const campaigns = yield listCampaignApi(accountId);
        if (campaigns === null || campaigns === void 0 ? void 0 : campaigns.length) {
            setCampaigns(campaigns);
        }
    });
    const applyFilters = () => __awaiter(void 0, void 0, void 0, function* () {
        let filteredCampaigns = [...campaigns];
        // campaign name filter
        if (selectedCampaigns.length) {
            filteredCampaigns = campaigns.filter((campaign) => {
                return selectedCampaigns.includes(campaign.id);
            });
        }
        // product filter
        if (selectedAdGroupCandidates.length) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return selectedAdGroupCandidates.some((candidate) => {
                    var _a, _b;
                    return (_b = (_a = campaign.adGroups[0]) === null || _a === void 0 ? void 0 : _a.candidates) === null || _b === void 0 ? void 0 : _b.some((adGroupCandidate) => {
                        return adGroupCandidate.id === candidate.id;
                    });
                });
            });
        }
        // start date filter
        if (startDateFrom) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return new Date(campaign.startDate) >= startDateFrom;
            });
        }
        if (startDateTo) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return new Date(campaign.startDate) <= startDateTo;
            });
        }
        // end date filter
        if (endDateFrom) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return new Date(campaign.endDate) >= endDateFrom;
            });
        }
        if (endDateTo) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return new Date(campaign.endDate) <= endDateTo;
            });
        }
        //city filter
        if (cityIds.length) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return (cityIds.filter((cityId) => campaign.cityIds.includes(cityId)).length > 0);
            });
        }
        //status filter
        if (status.length) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                let found = false;
                status.forEach((status) => {
                    switch (status) {
                        case CampaignSearchStatus.ACTIVE:
                            if (campaign.status ===
                                CampaignStatus.CAMPAIGN_STATUS_LIVE)
                                found = true;
                            break;
                        case CampaignSearchStatus.BOOKED:
                            if (campaign.status ===
                                CampaignStatus.CAMPAIGN_STATUS_BOOKED &&
                                campaign.statusUpdateReason ===
                                    CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_INVALID)
                                found = true;
                            break;
                        case CampaignSearchStatus.EXPIRED:
                            if (campaign.status ===
                                CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
                                campaign.statusUpdateReason ===
                                    CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_EXPIRED)
                                found = true;
                            break;
                        case CampaignSearchStatus.EXHAUSTED:
                            if (campaign.status ===
                                CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
                                campaign.statusUpdateReason ===
                                    CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_BUDGET_EXHAUSTED)
                                found = true;
                            break;
                        case CampaignSearchStatus.STOPPED:
                            if (campaign.status ===
                                CampaignStatus.CAMPAIGN_STATUS_STOPPED &&
                                campaign.statusUpdateReason ===
                                    CampaignStatusUpdateReason.CAMPAIGN_STATUS_UPDATE_REASON_UPDATED_BY_ADVERTISER)
                                found = true;
                            break;
                    }
                });
                return found;
            });
        }
        //ad pacing filter
        if (pacingEnabled !== undefined) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return campaign.pacingEnabled === pacingEnabled;
            });
        }
        //created by filter
        if (createdBy) {
            filteredCampaigns = filteredCampaigns.filter((campaign) => {
                return campaign.createdBy === createdBy;
            });
        }
        setCampaignResults(filteredCampaigns);
    });
    const toggleAdvanced = () => {
        setShowAdvancedFilters(!showAdvancedFilters);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tile, { className: styles.filtersTile },
            React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.filters },
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.CampaignName, { campaigns: campaigns })),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.Product, null)),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.StartDate, null)),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.EndDate, null))),
                showAdvancedFilters && (React.createElement("div", { className: cx(styles.filters, styles.filtersSecondRow) },
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.Cities, null)),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.CreatedBy, null)),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.CampaignStatus, null)),
                    React.createElement("div", { className: styles.filter },
                        React.createElement(Filters.AdPacing, null)))),
                React.createElement("div", { className: styles.advancedFilters },
                    React.createElement(TextButton, { onClick: toggleAdvanced, buttonSize: "medium", color: DlsColorTokens.primary, className: styles.advancedFiltersButton },
                        showAdvancedFilters && 'Hide',
                        " Advanced Search")),
                React.createElement("div", { className: styles.resultsButton },
                    React.createElement(AsyncButton, { variant: 'primary', onClick: applyFilters },
                        React.createElement("span", { className: styles.seeResultsText }, "See Results"),
                        React.createElement(ArrowRight, { className: styles.rightIcon, fill: "#fff" }))))),
        React.createElement("div", { className: styles.results },
            React.createElement(CampaignList, { isSearchPage: true, campaigns: campaignResults }))));
};
export default IndexPage;
